"use strict";

const style = require('!!css-loader?{"sourceMap":false}!postcss-loader!./style/index.css').default;

module.exports =`
    <style>${style}</style>
<!--<button>-->
<!--    <input id="menu__toggle" type="checkbox" />-->
<!--    <label class="menu__btn" for="menu__toggle">-->
<!--        <span></span>-->
<!--    </label>-->
<!--</button>-->
<!--    <button>-->
<button aria-label="toggler">
    <input type="checkbox" class="toggler" tabindex="-1" aria-hidden="true">
    <div class="hamburger"><div></div></div>
</button>
<!--    </button>-->
`;
